export default __webpack_public_path__ + "static/media/activeMenu.6a0c42cd.svg";